var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKibrislogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 37,
    viewBox: "0 0 53 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6951 0L14.9991 15.2864L17.9589 4.90395H8.6387L0 35.6706L45.8994 0H34.6951Z",
    fill: "#4F0077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8101 25.0943L19.0012 18.6136L30.8602 36.1115H18.2261L10.8101 25.0943Z",
    fill: "#4F0077"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3399 36.1115L37.3475 9.54065L28.1676 27.0252L32.1496 32.958L37.6147 22.7626L45.3582 36.1115H52.3399Z",
    fill: "#4F0077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKibrislogo);
export default __webpack_public_path__ + "static/media/kibrislogo.475efcd74c117ebae8d5b2edff4946af.svg";
export { ForwardRef as ReactComponent };